export const HURLY_CATEGORY_PAGE_ROUTE_PATH_REGEX = /[^\/]-xc-[^\/]/;

export const isHurlyPage = (url = '') => HURLY_CATEGORY_PAGE_ROUTE_PATH_REGEX.test(url);

export const isHurlyPageByWindow = () => {
  if (process.env.BROWSER && window) {
    return isHurlyPage(window.location.href);
  }

  return false;
};
